module.exports = __webpack_public_path__ + "files/bdf1fd4d07ea659bcf89b9c8354cfaba.svg";